/* ============================================================
   Showcase videos — scroll autoplay for "As Seen On" + "Weddings & Events".
   - Muted autoplay when ~50% visible (IntersectionObserver)
   - Only one video plays at a time; pause when scrolled away
   - Tap video or play button toggles; mute button toggles sound
   - Respects prefers-reduced-motion (no autoplay)
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var videos = Array.prototype.slice.call(
    document.querySelectorAll('video[data-showcase-video]')
  );
  if (!videos.length) return;

  function setPlaying(card, playing) {
    if (card) card.classList.toggle('is-playing', !!playing);
  }

  function pauseOthers(except) {
    videos.forEach(function (v) {
      if (v !== except && !v.paused) v.pause();
    });
  }

  function tryPlay(video) {
    pauseOthers(video);
    try {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } catch (e) { /* autoplay blocked — user can tap */ }
  }

  videos.forEach(function (video) {
    var card = video.closest('[data-video-card]');
    var toggle = card ? card.querySelector('[data-video-toggle]') : null;
    var muteBtn = card ? card.querySelector('[data-video-mute]') : null;

    video.addEventListener('play', function () { setPlaying(card, true); });
    video.addEventListener('pause', function () { setPlaying(card, false); });

    function togglePlay(e) {
      if (e) e.stopPropagation();
      if (video.paused) { tryPlay(video); } else { video.pause(); }
    }

    video.addEventListener('click', togglePlay);
    if (toggle) toggle.addEventListener('click', togglePlay);

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        muteBtn.classList.toggle('is-muted', video.muted);
        muteBtn.setAttribute('aria-pressed', String(!video.muted));
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
    }
  });

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.intersectionRatio >= 0.5) {
          if (video.paused) tryPlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: [0, 0.5, 1] });

    videos.forEach(function (v) { io.observe(v); });
  }
})();
